var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScheduleRecipientIcon = function SvgScheduleRecipientIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#ECF1F3",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A657B",
    d: "M17.64 17.883c.402 0 .73.283.73.628l-.001 1.257h1.07c.328 0 .596.34.596.754 0 .415-.298.754-.625.754h-1.041v1.096c-.036.345-.364.628-.728.628-.401 0-.729-.283-.729-.628v-1.096h-1.226c-.328 0-.596-.339-.596-.754 0-.414.268-.754.596-.754h1.226v-1.257c0-.345.328-.628.729-.628zm-1.702-2.585c3.821 0 6.908 3.1 6.908 6.901 0 .352-.264.64-.588.64-.323 0-.588-.288-.588-.64 0-3.13-2.587-5.655-5.762-5.655-3.175 0-5.732 2.556-5.732 5.655 0 .352-.265.64-.588.64-.323 0-.588-.288-.588-.64.03-3.802 3.116-6.901 6.938-6.901zM15.923 8c1.812 0 3.28 1.512 3.28 3.393 0 1.882-1.468 3.393-3.28 3.393-1.812 0-3.28-1.511-3.28-3.393 0-1.881 1.468-3.393 3.28-3.393zm0 1.203c-1.18 0-2.157.987-2.157 2.19 0 1.203.978 2.19 2.157 2.19 1.18 0 2.158-.987 2.158-2.19 0-1.203-.979-2.19-2.158-2.19z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleRecipientIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-recipient-icon.847ee5199043baebd74cce57678a1110.svg";